const sortEntities = (entities, sortByField) => {
  if (!sortByField) {
    return entities;
  }
  return entities.sort((a, b) => {
    const aField = a.getRelativeSingleField(sortByField);
    const bField = b.getRelativeSingleField(sortByField);
    if (typeof aField.value === "number" && typeof bField.value === "number") {
      return aField.value - bField.value;
    }
    return 0;
  });
};
export {
  sortEntities
};
//# sourceMappingURL=sortEntities.js.map
